import { NavLink } from "react-router-dom";
import Navbar from "../components/Navbar/NavBar";
import "./NotFound.css";
import { useTranslation } from "react-i18next";          // 🆕 i18n import

const NotFound = () => {
  const { t } = useTranslation("notFound");             // 🆕 namespace

  return (
    <>
      <Navbar />
      <div className="notfound">
        {/* image */}
        <img src="/404 error.svg" alt={t("alt")} />      {/* ⬅️ i18n */}
        {/* texts */}
        <h2>{t("title")}</h2>                            {/* ⬅️ i18n */}
        <h3>{t("subtitle")}</h3>                         {/* ⬅️ i18n */}
        {/* link */}
        <NavLink to="/dashboard">{t("link")}</NavLink>   {/* ⬅️ i18n */}
      </div>
    </>
  );
};

export default NotFound;
